document.addEventListener("DOMContentLoaded", function () {

	const overlay = document.querySelector('.review_pago_flex_overlay');

	if (!overlay) return;


	const STORAGE_KEY ='review_pago_flex_last_shown_' +	window.location.pathname;
  	const COOLDOWN_HOURS = 0;
	const COOLDOWN_MS = COOLDOWN_HOURS * 60 * 60 * 1000;

	// Revisar cooldown
	const lastShown = localStorage.getItem(STORAGE_KEY);

	if (lastShown) {
		const elapsed = Date.now() - parseInt(lastShown, 10);

		if (elapsed < COOLDOWN_MS) {
			return;
		}
	}

	let popupShown = false;

	function showPopup() {

		overlay.classList.add('review_pago_flex_visible');

		if (window.innerWidth <= 580) {
			document.body.classList.add('review_pago_flex_no_scroll');
		}
	}

	function hidePopup() {

		overlay.classList.remove('review_pago_flex_visible');
		document.body.classList.remove('review_pago_flex_no_scroll');
	}

	function checkScroll() {

		if (popupShown) return;

		const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
		const docHeight = document.documentElement.scrollHeight - window.innerHeight;

		if (docHeight <= 0) return;

		const scrollPercent = (scrollTop / docHeight) * 100;

		if (scrollPercent >= 25) {

			popupShown = true;

			showPopup();

			localStorage.setItem(STORAGE_KEY, Date.now());

			window.removeEventListener('scroll', checkScroll);
		}
	}

	window.addEventListener('scroll', checkScroll);

	// Cerrar popup
	const closeButton = document.querySelector('.review_pago_flex_close');

	if (closeButton) {
		closeButton.addEventListener('click', hidePopup);
	}

	// Cerrar al hacer click fuera del popup (opcional)
	overlay.addEventListener('click', function(e) {

		if (e.target === overlay) {
			hidePopup();
		}

	});

}); 


	if (typeof setGTMAttributes !== 'function') {
    function setGTMAttributes(id, {
        cta,
        location,
        label,
        event = 'cta_click'
    }) {
        const link = document.getElementById(id);

        if (!link) return;

        link.dataset.gtmLabel = label;
        link.dataset.gtmEvent = event;
        link.dataset.gtmCta = cta;
        link.dataset.gtmLocation = location;
    }
}

document.addEventListener("DOMContentLoaded", function () {
    const pathSegment = window.location.pathname
        .replace(/^\/|\/$/g, '')
        .replace(/\//g, '_');

    setGTMAttributes('review_pago_flex_cta', {
        cta: 'comprar_ahora',
        location: 'popup_review_' + pathSegment,
        label: 'comprar_ahora'
    });
});
